import config from 'config/app'
import lib from 'lib/commons'

import {
  CURRENT_USER_REQUEST_ERROR,
  CURRENT_USER_REQUEST_SUCCESS,
  CURRENT_USER_FETCHING,

  SHARE_ERROR,
  SHARE_SUCCESS,
  IS_SHARING,

  CHECK_MATCH_ERROR,
  CHECK_MATCH_SUCCESS,
  IS_CHECKING_MATCH,

  REGISTER_ERROR,
  REGISTER_SUCCESS,
  IS_REGISTERING,

  SPIN_ERROR,
  SPIN_SUCCESS,
  IS_SPINNING,

  GET_HISTORY_ERROR,
  GET_HISTORY_SUCCESS,
  IS_GETTING_HISTORY,

} from './actions'

const initialState = {
  loading: false,
  login: false,
  user: {},
  playerPieces: [],
  eventStarted: 0,
  // playNormal: 0,
  shared: false,
  popupGuide: '',
  bannerGift: '',
  eventStartTime: '',
  eventEndTime: '',

  isCheckingMatch: false,
  isSharing: false,
  isRegistering: false,
  isSpinning: false,
  isGettingHistory: false
}

export default function currentUserReducer(state = initialState,  { type, payload } = action) {
  switch (type) {
    case CURRENT_USER_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        login: true,
        user: payload.user,
        eventStarted: payload.event_started,
        playerPieces: payload.player_pieces,
        popupGuide: payload.popup_guide,
        bannerGift: payload.banner_gift,
        eventStartTime: payload.event_start_time,
        eventEndTime: payload.event_end_time,
        errorGlobal: ''
      }
      break;
    case CURRENT_USER_REQUEST_ERROR:
      return {
        ...state,
        loading: false,
        eventStarted: payload.event_started,
        playerPieces: payload.player_pieces,
        popupGuide: payload.popup_guide,
        bannerGift: payload.banner_gift,
        eventStartTime: payload.event_start_time,
        eventEndTime: payload.event_end_time,
        errorGlobal: 'Không có thông tin user',
      }
      break;
    case CURRENT_USER_FETCHING:
      return {
        ...state,
        loading: true
      }
      break;

     //SHARE
    case SHARE_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          spin_times: payload.user.spin_times,
          total_spin_times: payload.user.total_spin_times
        },
        shared: true,
        isSharing: false
      }
      break
    case SHARE_ERROR:
      return {
        ...state,
        isSharing: false
      }
      break
    case IS_SHARING:
      return {
        ...state,
        isSharing: true
      }
      break

    //CHECK MATCH
    case CHECK_MATCH_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          spin_times: payload.user.spin_times,
          total_spin_times: payload.user.total_spin_times,
          play_normal: payload.play_normal,
        },
        shared: payload.shared,
        isCheckingMatch: false
      }
      break
    case CHECK_MATCH_ERROR:
      return {
        ...state,
        isCheckingMatch: false
      }
      break
    case IS_CHECKING_MATCH:
      return {
        ...state,
        isCheckingMatch: true
      }
      break

    //SPIN
    case SPIN_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          spin_times: payload.user.spin_times,
          spun_times: payload.user.spun_times,
          need_register: payload.user.need_register
        },
        isSpinning: false
      }
      break;
    case SPIN_ERROR:
      return {
        ...state,
        isSpinning: false
      }
      break;
    case IS_SPINNING:
      return {
        ...state,
        isSpinning: true
      }
      break;

    // GET HISTORY
    case GET_HISTORY_SUCCESS:
      return {
        ...state,
        userHistory: payload,
        isGettingHistory: false
      }
    case GET_HISTORY_ERROR:
      return {
        ...state,
        isGettingHistory: false
      }
    case IS_GETTING_HISTORY:
      return {
        ...state,
        isGettingHistory: true
      }

    // REGISTER
    case REGISTER_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          need_register: 0,
          name: payload.user.name,
          phone_number: payload.user.phone_number,
          address: payload.user.address,
        },
        isRegistering: false
      }
    case REGISTER_ERROR:
      return {
        ...state,
        isRegistering: false
      }
    case IS_REGISTERING:
      return {
        ...state,
        isRegistering: true
      }

    default:
      return state
  }
}
